import graphql__a5711c28322fb46f553d from "./__generated__/ContributionsDatavizSearch_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { Outlet } from "react-router";

import { getContributionsAnchorId } from "../../../Utils/anchorIds";
import AnchorTarget from "../../../Utils/AnchorTarget";
import ContributionsDatavizTabs from "./ContributionsDatavizTabs";
import ContributionsDatavizSearchFilters from "./ContributionsDatavizSearchFilters";
import ContributionsDatavizSearchSort from "./ContributionsDatavizSearchSort";
import ContributionsDatavizSearchResults from "./ContributionsDatavizSearchResults";

const ContributionsDatavizSearch = props => {
  const participativeModule = useFragment(
    ContributionsDatavizSearch_participativeModule,
    props.participativeModule
  );
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <div className="participative-datavisualization-container container">
      <AnchorTarget id={contributionsAnchorId} />

      <ContributionsDatavizTabs
        participativeModule={participativeModule}
        searchTabActive={true}
      />

      <div className="row">
        <div className="col-md-4">
          <ContributionsDatavizSearchFilters participativeModule={participativeModule} />
        </div>
        <div className="col-md-8">
          <ContributionsDatavizSearchSort />
          <ContributionsDatavizSearchResults participativeModule={participativeModule} />
        </div>
      </div>

      <Outlet />
    </div>
  );
};

const ContributionsDatavizSearch_participativeModule = graphql__a5711c28322fb46f553d;

export default ContributionsDatavizSearch;
